export default {
  accept: 'Accept',
  accepted_from: 'Accepted from',
  add_calendar_event: 'Add event',
  request_new_vac: 'Request new vacation',
  hint_oneday: 'Hint: To choose just one day, double click it',
  add_event_for_user: 'Create event for user',
  analytics: 'Analytics',
  calendar: 'Calendar',
  calendar_events: 'Calendar events',
  social_groups: 'Social Groups',
  close: 'Close',
  add_folder: 'Add folder',
  new_folder_name: 'New folder name',
  create_new_folder: 'Create new folder',
  upload_file: 'Upload file',
  upload: 'Upload',
  create_docPool: 'Create',
  no_results: 'No results',
  no_posts_yet: 'No posts yet...',
  file_download: 'Download file',
  search_result: 'Result',
  search: 'Search...',
  employee_number: 'Employee Number',
  search_filter: 'Search',
  employee_tooltip: 'Here you can add and search for employees',
  data_import_tooltip: 'Here you can import remaining vacations using a csv file',
  library_tooltip: 'Here you can create links for specific themes/websites',
  export_tooltip: 'The overview can be displayed up to a certain month in order to adjust vacation days if necessary',
  social_tooltip: 'You can add and manage social business groups in here',
  wkg_tooltip: 'You can add and manage working groups in here',
  year: 'Year',
  month: 'Month',
  apply_working_time: 'Apply working time',
  employee_year_calendar_tooltip: 'A function to have the vacation days of a specific employee at a glance',
  daily_report_tooltip: 'Here you can set the performance of certain employees from groups',
  daily_report: 'Daily report',
  select_two_dates: 'Please select two dates',
  dispo_tooltip:
    'A specially created overview for dispatch planners to determine the performance of employees. In addition, good hours and vacation days for each employee are visible here',
  hr_tooltip:
    'The comments of the MRP planning are created here. Visible here is: Creator, date, comment, creation date, employee number and the status (completed or not)',
  deputy_tooltip: 'This function allows you to add or delete substitutes for specific groups',
  comment: 'Comment',
  date: 'Date',
  comments: 'Comments',
  create_new_comment: 'Create a new comment ...',
  days: 'Days',
  document_pool: 'Document pool',
  constriction_images: 'Construction Sites',
  upload_document: 'Upload document',
  add_comment: 'Add comment...',
  final_comment: 'Close comments',
  days_left: 'days left',
  days_taken: 'days taken',
  working_hours: 'Working hours',
  decline: 'Decline',
  quarantine: 'Quarantine',
  confirmed_by: 'confirmed by',
  no_links_yet: 'No links yet...',
  important_links: 'Here you can find important links',
  library: 'Library',
  declined_from: 'Declined from',
  delete: 'Delete',
  edit: 'Edit',
  education_company: 'Inter-company training',
  education_vacation: 'Training leave',
  email: 'E-mail',
  employee: 'Employee',
  employees_on_vacation: 'Employees on vacation',
  end: 'End',
  retry: 'Retry',
  january: 'January',
  february: 'February',
  march: 'March',
  april: 'April',
  may: 'May',
  june: 'June',
  july: 'July',
  august: 'August',
  september: 'September',
  october: 'October',
  november: 'November',
  december: 'December',
  error: 'Error',
  error_max_file_upload_size: 'File size has to be smaller than {data}.',
  error_mime_type_not_allowed: 'File has to be {data}.',
  feessbook: 'Feessbook',
  flex_time: 'Flexitime adjustment / Overtime reduction',
  freetime_616: 'Leave of absence with pay according to §616 BGB',
  go_back: 'Go back',
  change_password: 'Change password',
  deleted_deputy: 'Deputy deleted',
  set_deputy: 'Deputy set',
  password_doesnt_match: 'Password doesnt match',
  please_apply_password: 'Please apply password',
  password_changed: 'Password changed',
  back: 'Back',
  group: 'Group',
  half_day: 'Half day',
  next_step: 'Next step',
  hide: 'Hide',
  history_request: 'Processed vacation requests',
  no_old_requests: 'No old requests',
  new_vacation_request: 'New vacation request',
  holi_day: 'Holiday',
  last_updated: 'Last updated: {date}',
  like: 'Like',
  liked: 'Like',
  likes: 'Like|Likes',
  loading: 'Loading ...',
  login: 'Login',
  logout: 'Logout',
  menu: 'Menu',
  news: 'News',
  favourites: 'Favourites',
  operations: 'Operations',
  in_progress: 'In progress',
  removed_favourite: 'Removed favourite',
  added_favourite: 'Added favourite',
  no_entries: 'No entries',
  no_more_requests: 'No more requests',
  notifications: 'Notifications',
  open_requests: 'Open requests',
  no_open_requests: 'No open requests',
  open_vacation_requests: 'Open vacation confirmations',
  parenting_time: 'Parental leave',
  parseserver_error_101: 'Wrong credentials.',
  parseserver_error_119: 'You do not have the permission to do that.',
  parseserver_error_1: 'Whoops, something went wrong.',
  parseserver_error_200: 'Username / Password required',
  parseserver_error_202: 'User with this E-Mail exists already.',
  parseserver_error_141: 'This user was deactivated.',
  password: 'Password',
  please_state_mail: 'Please state mail',
  please_state_password: 'Please state password',
  please_state_workspace: 'Please state workspace',
  pinned_posts: 'Pinned Posts',
  post: 'Post',
  post_placeholder: 'Whats new...',
  posting: 'Posting ...',
  pull_to_refresh: 'Pull to refresh',
  reason: 'Reason',
  release_to_load: 'Release to load',
  you_are_in_no_groups: 'You are in no groups',
  remember_me: 'Remember me',
  request_created_at: 'Request created at',
  summary: 'Summary',
  save: 'Save',
  mon: 'Mon',
  tue: 'Tue',
  wed: 'Wed',
  thr: 'Thr',
  fri: 'Fri',
  sat: 'Sat',
  sun: 'Sun',
  school: 'Vocational school',
  search_employees: 'Search employees ...',
  select: 'Please select',
  select_working_group: 'Select a group',
  send: 'Send',
  settings: 'Settings',
  show_all: 'Show all',
  show_inactive_employees: 'Show inactive employees',
  show_more: 'More',
  sick_with_money: 'Sick with pay',
  sick_without_money: 'Sick without pay',
  special_vacation: 'Special leave',
  start: 'Start',
  still_open: 'Still open',
  submit: 'Submit',
  upload_media: 'Upload media',
  username: 'Username',
  no_vac_type: 'No vacation type assigned',
  vacation: 'Vacation',
  vac: 'Vacation',
  vacation_request: 'Vacation request',
  vacation_requests_starting_soon: 'Vacation requests starting soon',
  vacation_without_money: 'Vacation without pay',
  viewed_by: 'Viewed by',
  visible_for: 'Visible for:',
  welcome: 'Welcome',
  working_group_calendar: 'Team calendar',
  workinggroup_calendar: 'Teamkalender',
  confirm: 'Confirm',
  canceled_2: 'Cancellation',
  declined: 'Declined',
  cancel: 'Cancel',
  groups: 'Groups',
  my_groups: 'My groups',
  my_vacation_overview: 'My vacation overview',
  open: 'Open',
  accepted: 'Accepted',
  canceled: 'Canceled',
  selected_construction: 'Selected construction',
  construction_images: 'Construction Images',
  select_construction: 'Select construction site',
  name_optional: 'Name (optional)',
  choose_pics: 'Choose pictures',
  open_entries: 'Open entries',
  done_entries: 'Done entries',
  done: 'Erledigt',
  event_was_added: 'Event was added',
  admin: 'Admin',
  machine_diary: 'Machine diary',
  select_machine: 'Select machine',
  current_machine: 'Current machine',
  open_vacation: 'Open vacation',
  workspace: 'Workspace',
  post_analytics: 'Post analytics',
  no_notifications_yet: 'No notifications yet ...',
  sick_report_exist: 'Notification of illness submitted',
  update_successful: 'Update successful',
  maternity_protection: 'Maternity protection',
  quarantine_without_money: 'Quarantine without continued payment of wages',
  quarantine_with_money: 'Quarantine with continued payment of wages',
  pin_this_post: 'Pin this post',
  delete_this_post: 'Delete this post',
  create_calendar_event: 'Create calendar event',
  update_calendar_event: 'Update calendar event',
  translation: 'Translation',
  calendar_event_background: 'Background color',
  calendar_event_color: 'Text color',
  extra: 'Extra',
  create: 'Create',
  key: 'Key',
  preview: 'Preview',
  search_calendar_event: 'Search for calendar event',
  german: 'German',
  anonym: 'anonymous',
  english: 'English',
  example: 'Example',
  next: 'Next',
  not_translated: 'not translated',
  profile: 'Account',
  failed: 'Failed',
  to_dos: "To do's",
  load_more: 'Load more',
  log_out: 'Log Out',
  active: 'Active',
  inactive: 'Inactive',
  vacationdays: 'Vacation days',
  sokabau: 'SOKA-BAU',
  vacation_type: 'Type of vacation',
  general: 'General',
  misc: 'More information',
  updated_request: 'Updated request',
  enter_reason: 'Enter the reason',
  select_two_days: 'Please select 2 days',
  to_do: 'To-do lists',
  leaving_date: 'Left the company at',
  workinggroup: 'Department|Departments',
  press_enter_to_search: 'Press Enter to search',
  i_like: 'Like',
  dont_like_it: "Don't like",
  upload_profileimage: 'Upload profile picture',
  camera: 'Camera ...',
  photo_library: 'Choose from camera roll ...',
  delete_profile_image: 'Delete profile image',
  reset_password_admin_hint: 'The password will be set to the birthdate of the user. (DDMMYYYY)',
  reset_password: 'Reset password',
  passwort_reset_successful: 'Password was set successfully',
  invalid_birthdate: 'Invalid birthdate',
  password_reset_confirm: 'Do you really want to reset the password?',
  mandatory_field: 'Mandatory field',
  without_weekend_days: 'Without weekend days',
  enter_note_here: 'Enter note here',
  select_action: 'Select action',
  make_photo: 'Shoot photo',
  choose_from_gallery: 'Choose a photo from the gallery',
  cancel_1: 'Abort',
  add_extra_days: 'Add additional leave days',
  amount_of_days: 'Number of days',
  reason_is_missing: 'The reason is missing',
  days_must_be_above_0: 'The number of days needs to be above 0',
  extra_days_added: 'Additional days have been added',
  add_group: 'Add group',
  choose_files: 'Choose files',
  select_tags: 'Select tags',
  added_file_success: 'File successfully added',
  enter_name: 'Please enter at least one name',
  added_folder_success: 'Folder successfully added',
  add_note: 'Add note',
  note_added: 'Note added',
  add_shorten_vac: 'Shorten vacation time',
  shorten_vac_success: 'Vacation time successfully shortened',
  add_tag: 'Add tag',
  new_tag_name: 'Name',
  added_tag_success: 'Tag successfully added',
  pls_enter_reason: 'Please enter the reason',
  contact_information: 'Contact information',
  update_1: 'Update',
  pls_fill_out_all_fields: 'Please fill out all fields',
  add_new_link_success: 'New link successfully added',
  no_change_error: 'You did not make any changes',
  changed_link_success: 'Link successfully modified',
  delete_link_success: 'Link successfully deleted',
  create_new_employee: 'Create new employee',
  firstname: 'Firstname',
  lastname: 'Lastname',
  username_1: 'Username',
  birthdate_equals_pw: 'Date of birth (YYYY-MM-DD, will be used to generate the password)',
  employee_nr: 'Employee no.',
  start_day_1: 'Date of entry',
  phone_number: 'Phone number',
  vac_amount: 'Number of vacation days',
  social_business_color: 'Social business color',
  has_daily_report: 'Has daily report',
  is_active: 'Is still employed',
  please_fill_out_mandatory_fields: 'Please fill out all mandatory fields',
  create_employee_success: 'New employee successfully created',
  change_employee_information_success: 'Employee information successfully changed',
  create_post: 'Create post',
  post_created: 'Post created',
  new_vacation_for: 'New vacation for',
  request: 'Request',
  a_request: 'Request',
  apply: 'Apply',
  vacation_without_fr_workflow: 'Vacation without approver workflow',
  hint_halfday: 'Hint: To select one single day, click on the same date twice.',
  summary_vac_request: 'Summary of the new vacation request',
  used_days: 'Used days',
  request_sent: 'Request sent',
  back_to_overview: 'Back to the overview',
  not_enough_vac: 'Not enough vacation days available',
  vacation_request_created: 'The vacation request was created',
  deleted_successfully: 'Successfully deleted',
  not_possible: 'This is unfortunately not possible',
  delete_post: 'Delete post',
  delete_post_question: 'Do you really want to delete this post?',
  no: 'No',
  yes: 'Yes',
  post_deleted: 'Post successfully deleted',
  logs: 'Logs',
  sorted_from_oldest: 'Sorted from oldest to youngest',
  delete_calendar_event: 'Delete calendar event',
  delete_calendar_event_entry: 'Delete calendar event entry',
  duplicate_key_error: 'That key is already in use',
  create_calendar_event_entry_success: 'New calendar event entry created',
  edit_calendar_event_entry_success: 'Calendar event entry successfully modified',
  create_calendar_event_entry: 'Create calendar event entry',
  edit_calendar_event_entry: 'Edit calendar event entry',
  confirm_keep_event_entry_key:
    'Do you want to create a new entry for this calendar event entry key? Otherwise all events in the calendar with this key will be deleted',
  edit_deputy: 'Edit deputy',
  deputy_for: 'Deputy for',
  edit_small: 'edit',
  choose_deputy: 'Choose deputy',
  deputy_gets_all_vac_requests: 'If the boss is on vacation, all vacation requests will be directed to the deputy',
  chosen_deputy: 'Currently chosen as deputy',
  default_deputy: 'Choose default deputy',
  default_deputy_when_chef_vac:
    'Default deputy will be used if the boss is on vacation and no other deputy has been chosen',
  default_deputy_atm: 'Currently chosen default deputy',
  create_working_group: 'Create working group',
  working_group_name: 'Working groups',
  working_group_color: 'Working group color',
  supervisor: 'Supervisor',
  optional: 'Optional',
  deputy: 'Deputy',
  default_deputy_in_case_of_holiday: 'Default deputy (automatically chosen if the boss is on vacation)',
  second_supervisor: '2. Supervisor',
  second_supervisor_decides_over_vac: 'Number of vacation days the second supervisor may decide over',
  shortcut_working_group: 'Acronym of the working group',
  vac_privacy_for_working_group: 'Vacation visible for all members of the working group',
  create_working_group_success: 'New working group successfully created',
  edit_working_group_success: 'Working group successfully edited',
  edit_post: 'Edit post',
  edit_post_success: 'Post successfully edited',
  social_group_name: 'Name of the social business group',
  social_group_color: 'Color of the social business group',
  create_social_group_success: 'New social business group created',
  edit_social_group_success: 'Social business group successfully edited',
  please_set_priority: 'Please set the priority',
  ticket_uc: 'Ticket',
  create_success: 'created',
  edit_success: 'successfully edited',
  deleted: 'deleted',
  personal_details: 'Personal details',
  extra_days: 'Additional vacation days',
  startDate: 'Start date',
  no_extra_days: 'No additional vacation days',
  short_vac: 'Shorten vacation',
  no_shorten_vacs: 'No shortened vacation',
  vac_requests: 'Vacation requests',
  no_requests_yet: 'No vacation requests yet',
  legend: 'Legend',
  chosen: 'Chosen',
  chose_pics: 'Choose pictures (optional)',
  entry_created: 'Entry created',
  something_went_wrong: 'Something went wrong',
  confirm_post: 'Confirm post',
  understood: 'Understood',
  vac_request_from: 'Vacation request from',
  really: 'really',
  no_dont: 'No, don´t',
  cancel_2: 'Cancel',
  canceled_successfully: 'Successfully canceled',
  delete_error: 'Requests that have not been accepted, cannot be canceled. Please delete.',
  excel_export: 'Excel export',
  staff: 'Staff',
  admin_area: 'Admin area',
  year_calendar: 'Annual calendar',
  performance_recorder: 'Performance recorder',
  dispo_planner: 'Overdraft credit planer',
  todos: "HR ToDo's",
  deputy_ruling: 'Deputy arrangement',
  reports: 'Reports',
  import_data: 'Import data',
  manage_groups: 'Manage groups',
  year_to_month_export: 'Export data',
  manage_link: 'Manage links',
  annual_financial_statement: 'Annual financial statement',
  active_response_wanted: 'Active feedback is requested',
  choose_group_if_empty_all: 'Select groups',
  download_success: 'Download successful',
  click_to_open: 'Click to open',
  delete_success_ws_lc: ' successfully deleted.',
  file: 'File',
  created_by: 'Created by:',
  finish: 'Complete',
  groups_1: 'Groups:',
  position: 'Position',
  vac_type: 'Vacation type',
  vac_days: 'Vacation days',
  your_claim_for: 'Your claim for',
  amounts: 'amounts to',
  plus_hours_at_the_end_of_month: 'Overtime in hours at the end of the month',
  hours: 'hours',
  request_reset: 'Request edited',
  vacation_request_1: 'Vacation request:',
  no_comments: 'No comments',
  increase_time: 'Increase space of time',
  weekends_holiday: 'W-END/HOL',
  watch: 'Watch',
  upload_files: 'Upload files',
  unpin: 'Unpin',
  pin: 'Pin',
  pin_successful: 'Successfully pinned',
  unpin_successful: 'Successfully unpinned',
  pics_uploaded: 'Pictures have been uploaded',
  please_choose_folder: 'Please select a folder',
  no_rights_pls_inform_your_admin: 'No authorization. Please inform your admin.',
  server_connection_lost: 'Connection failed',
  employee_on_vacation: 'Employee on vacation',
  show_legend: 'Show legend',
  rest_vac_import: 'Transfer remaining vacation days',
  needed_file_for_import:
    'A .csv file is needed, in which a "withEmpID" is assigned to each "Vacation" and "from_date"(Format:\n' +
    'DD/MM/YYYY).',
  rest_vac_success: 'Remaining vacation days successfully added',
  no_uploaded_data: 'No file uploaded',
  deputy_for_area: 'Deputy for department',
  lastname_1: 'Name',
  chef: 'Boss',
  short_chef: 'Second in command',
  hide_empty_cells: 'Hide empty cells',
  set_as_default: 'Select choice as default',
  set_new_default: 'New default set',
  staff_details: 'Staff details',
  update: 'Update',
  claim: 'Claim',
  taken: 'Taken:',
  rest_vac_1: 'Remaining vacation days',
  staff_1: 'Staff:',
  make_annual_financial_statement: 'Prepare the annual financial statement',
  fix_annual_financial_statement: 'Restore the annual financial statement',
  successfully_vac_imported: 'Vacation days have been successfully transferred',
  successfully_afs_fixed: 'Vacation days have been successfully restored',
  create_links: 'Add links to the link collection',
  social_business_groups: 'Social business groups',
  working_groups: 'Working groups',
  old_vac_requests: 'Past vacation requests',
  reset: 'Reset',
  create_report: 'Create reports',
  please_select_report: 'Please select a report',
  please_select_coworker: 'Please select an employee',
  please_enter_year: 'Please enter a year',
  please_enter_date: 'Please enter a date in the format dd.mm.yyyy, for example 31.01.2022',
  date_example: 'Date (dd.mm.yyyy, e.g. 31.01.2022)',
  select_coworker: 'Select an employee',
  search_employee: 'Find an employee',
  export_atm: 'Current export (year to month)',
  download: 'Download',
  default_vac_days: 'Default vacation days',
  special_vac: 'Special leave',
  amount_days: 'Number of days',
  start_day: 'Start (Number of days begins with the start date. Weekends and holidays are not counted)',
  posts: 'Posts',
  created_at: 'Created at:',
  from_day: 'From',
  shorten_vac: 'Shortened vacation',
  work_groups: 'Task groups',
  employees: 'Employees',
  print: 'Print',
  no_work_groups: 'No task groups available',
  no_staff: 'No employees available',
  no_fitting_workspace: 'Workspace does not exist, please review your input',
  create_vac_request: 'Create a vacation request',
  from_to: 'From - To',
  status: 'Status',
  create_social_group: 'Create social business group',
  update_social_group: 'Edit social business group',
  color_desc: 'Green = Approved, Red = Denied, Grey = Canceled, Blue = Open, Orange = Remaining vacation days',
  purple_desc: 'Violet = Daily report available',
  one_day_hint: 'Hint: To choose a single day, click on the same date twice.',
  U_accepted: 'Vacation request approved',
  OU_open: 'Vacation request open',
  U_declined: 'Vacation request denied',
  U_canceled: 'Vacation request canceled',
  create_new_post: 'Create a new post',
  admin_section: 'Admin section',
  planner: 'Planer',
  choose_documents: 'Choose files',
  links_manager: 'Link manager',
  tenant_not_found: 'This workspace was not found.',
  new_password: 'New password',
  confirm_new_password: 'Confirm new password',
  select_report: 'Select report',
  select_group: 'Select group',
  name: 'Name',
  color: 'Color',
  select_permission: 'Select permission (leave empty to allow everyone access to this folder)',
  note: 'Note',
  board_name: 'Name of the board',
  create_board: 'Create board',
  edit_board: 'Edit board',
  update_board: 'Update board',
  move_tickets: 'Move tickets that haven´t been closed yet to another board?',
  completion: 'Completion',
  link_example: 'Link (www.example.com)',
  description: 'Description',
  select_employee: 'Select employee',
  select_boss: 'Select boss',
  select_short_chef: 'Select second in command',
  title: 'Title',
  priority: 'Priority',
  create_ticket: 'Create ticket',
  edit_ticket: 'Edit ticket',
  can_only_select_images: 'You can only select images!',
  add_date_time: 'Write date on images',
  edit_folder: 'Edit folder',
  delete_folder: 'Delete folder',
  match_name_to_delete: 'Enter the exact name of the folder to delete it',
  edit_folder_success: 'Folder successfully edited!',
  folder_deleted: 'Folder deleted!',
  folder_not_deleted: 'Folder not deleted!',
  remove_tag: 'Delete tag',
  remove_tag_name: 'Enter the exact name of the tag to delete it',
  remove_tag_success: 'Tag deleted!',
  folders_with_tag: 'Attention, the following folders are marked with this tag:',
  tags_removed: 'These markings will be removed upon deleting the tag!',
  folder_delete_hint: 'If you really want to delete the folder, you have to enter it´s name' +
    ' correctly in the input field above, and click on delete below.',
  folders_delete_hint: 'Attention, the following sub-folders will be deleted as well:',
  files_delete_hint: 'Attention, the following files will be deleted as well:',
  files_deleted: 'Files contained in the folder deleted!',
  files_not_deleted: 'Files contained in the folder not deleted!',
};
